<div class="flex flex-col gap-4">
  <div class="rounded-2xl bg-white p-4">
    <app-change-language
      [currentLanguage]="currentLanguage()"
      (changeLanguage)="changeLanguage($event)"
      [busy]="isChangingLanguage().isChangingLanguage"
    ></app-change-language>
  </div>
  <div class="rounded-2xl bg-white p-4">
    <app-change-password
      [busy]="isChangingPassword().isChangingPassword"
      (changePassword)="changePassword($event)"
    ></app-change-password>
  </div>
  <!-- <div class="rounded-2xl bg-white p-4">
    <app-theme-switcher></app-theme-switcher>
  </div> -->
</div>
